import { getConfig } from "../helpers/addin-config";
import { setConfig } from "../helpers/addin-config";
import { updateFontSize } from "../helpers/addin-config";
import { getAbsoluteUrl } from "../helpers/addin-config";
//TW: disable roaming settings FRE, use localstorage instead
//import { getShowedFREVer } from "../helpers/addin-config";
//import { setShowedFREVer } from "../helpers/addin-config";

(function() {
  'use strict';

  const ver = "1.2.0.8";

  const NavType = {
    Page: 0,
    OfficeApiDialog: 1,
    FloatingDiv: 2
  };

  let _item;
  let _isFREOpen = !1;

  let navTypeSettings = NavType.FloatingDiv;

  let config;
  let newConfig;
  let settingsDialog;
  
  let isInternetHeadersLoaded = !1;

  /* let itemParsingState = {
    isBodyParsed: !1
  } */
  window.isBodyParsed = !1;

  let isOutlook2016AndBelow = !1;  

// Legacy fallback for older Outlook versions
/* Office.initialize = function(reason) {
    trackJs.track('Office.initialize is called');
}; */

function diagLog(msg){
  var prefix = "Test:";
  //trackJs.track(prefix + msg);
}

function initOfficeOnReady(){

  diagLog('initOfficeOnReady');

  Office.onReady(function(info) {    
    
      diagLog('onReady started');

      if(isFREOpen()){
          return;
      }

      if(isPersistenceSupported()){
        diagLog('setup addHandlerAsync');

        Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, onItemChanged);
      }

      diagLog('check host');

      if (info.host === Office.HostType.Outlook) {
        diagLog('is outlook');
        const version = Office.context.mailbox.diagnostics.hostVersion;
        diagLog("Outlook version: " + version);

        let majorMinor = 0;
        //try{
          diagLog("Version is: ");
          const arrVer = version.split('.');
          diagLog("Post split" + arrVer.length);
          majorMinor = parseFloat(`${arrVer[0]}.${arrVer[1]}`);
          diagLog("Outlook major.minor: " + majorMinor);
        //}
        //catch(e){
        //  diagLog("Outlook version parsing error: " + e);
        //}

        isOutlook2016AndBelow = (majorMinor <= 16.0);

        //showErrorDialog(`Version: ${version} major.minor: ${majorMinor} isOutlook16andbelow: ${isOutlook2016AndBelow}`);
      }

      if(isOutlook2016AndBelow){
        diagLog('is Outlook 2016 And Below');
        $('#mw-btn-ask').hide();
        navTypeSettings = NavType.FloatingDiv;
      }

      if(navTypeSettings == NavType.Page){
        diagLog('use this when settings on another page'); 
        updateFontSize_whenSettingsPage();  
      }  

      diagLog('get config');

      config = getConfig();

      diagLog('setup page');

      newConfig = {};
      newConfig.fontSize = "s";

      if (config && config.fontSize) {
        newConfig.fontSize = config.fontSize;
        updateFontSize("mw-prop-list", config.fontSize);
        updateFontSize("mw-prop-list-advanced", config.fontSize);
      }    

      if (info.host === Office.HostType.Outlook) {
        //document.getElementById("sideload-msg").style.display = "none";
        //document.getElementById("app-body").style.display = "flex";
      }

      _item = Office.context.mailbox.item;

      if(navTypeSettings == NavType.FloatingDiv){
        // if settings via floating div, setup controls on the page
        initModalSettingsDialog();
      }

      // When the settings icon is selected, open the settings dialog.
      $('#mw-btn-settings').on('click', function () {
          openSettings(navTypeSettings);
        });

      $('#mw-btn-refresh').on('click', function () {
          refreshDisplay();
        });

      $('#mw-btn-ask').on('click', function(){
        askAgent(_item);
      });

      $('#mw-btn-ok-error').on('click', function () {
        hideErrorDialog();
      });

      $('#mw-btn-start').on('click', function () {
        hideFirstRunExperience();
        refreshDisplay();
      });

      // showedFRE is created and set to the current version when you call showFirstRunExperience().
      if (checkIfShowFRE(ver)) {
          showFirstRunExperience();
      }
      else{
        retrieveAndShowMailboxItemData();
      }


    });


  }


  function onItemChanged(item) {    
    diagLog('onItemChanged');

    closeSettings(navTypeSettings);

      _item = Office.context.mailbox.item;

      $('#mw-btn-start')
        .off('click') // Remove all previous click handlers
        .on('click', function () {
          // New click handler
          hideFirstRunExperience();
          refreshDisplay();
        });

      // showedFRE is created and set to the current version when you call showFirstRunExperience().
      if (checkIfShowFRE(ver)) {
          showFirstRunExperience();
      }
      else{
        refreshDisplay();
      }

  }

  function refreshDisplay(){
    resetAdvanced();

    window.isBodyParsed = !1;
    //itemParsingState.isBodyParsed = !1;
    retrieveAndShowMailboxItemData();
  }

  function isInternetHeadersSupported(item){
    //getAllInternetHeadersAsync was introduced in Mailbox 1.5, but even if the requirement set is technically present, mobile clients can still block specific APIs.

    let ret = !1;
    if (Office.context.requirements.isSetSupported("Mailbox", "1.5") && item && item.getAllInternetHeadersAsync !== undefined) {
      ret = !0;
    }

    diagLog('isInternetHeadersSupported: ' + ret);

    return ret;
  }

  function isFREOpen(){
    return $('#first-run-experience').is(':visible');
}

function checkIfShowFRE(ver){
    if(typeof getShowedFREVer === 'function'){
      const showedFRE = getShowedFREVer();
      return (!showedFRE || ver != showedFRE);
    }
    else
    {
      return localStorage && ver != localStorage.getItem("showedFREVer")
    }
}

function showFirstRunExperience(){
    _isFREOpen = !0;
    $("#first-run-experience").show();
    $('.ms-Dialog-overlay').show();
    
    if(typeof setShowedFREVer === 'function'){
        setShowedFREVer(ver, function(result){
            if (result.status !== Office.AsyncResultStatus.Succeeded) {
                diagLog(`Action failed with message ${result.error.message}`);
            } else {
                diagLog(`Settings saved with status: ${result.status}`);
            }
        });
    }
    else
    {
        localStorage.setItem("showedFREVer", ver);
    }
  }

  function hideFirstRunExperience(){
    $('.ms-Dialog-overlay').hide();
    $("#first-run-experience").hide();
    _isFREOpen = !1;
  }

  function retrieveAndShowMailboxItemData(){
    const item = _item || Office.context.mailbox.item;

	  diagLog('retrieveAndShowMailboxItemData');

    $('#mw-spin-basic').show();

    if(isInternetHeadersSupported(item)){

      

      item.getAllInternetHeadersAsync(function (result) {

        isInternetHeadersLoaded = !0;

        $('#mw-spin-basic').hide();

        //update advanced
        let $insertAt = $('#mw-prop-list-advanced');
        $insertAt.empty();

        if (result.status === Office.AsyncResultStatus.Succeeded) {
            const headers = result.value;
            appendListItem($insertAt, "Internet Headers:", [headers]);

            showAdvancedSection();

            displayMailboxItemData(item, headers);
        } else {
          const err = result.error;
          let errMsg = 'Not available';
          if(err){            
            //errMsg = `Not available: ${err.name}:${err.code}:${err.message}`;
            errMsg = `Not available: ${err.code}`;
          }
          appendListItem($insertAt, "Internet Headers:", [errMsg]);
          console.error(`Failed to get Internet Headers: ${errMsg}`);

          displayMailboxItemData(item, null);
        }
      });
         
    }
    else{
      //internet headers not supported

      $('#mw-spin-basic').hide();

      displayMailboxItemData(item, null);
    }
  }


  //NavType: floating div only
  //  
  function initModalSettingsDialog() {
      
    $(document).on('msChoicefield', function(event) {
        // event.srcElement is the <label> that was activated
        var $label = $(event.target || event.srcElement);
        // Find the corresponding hidden input (sibling of the label)
        var $input = $label.siblings('input[type=radio]');
        newConfig.fontSize = $input.val();

        updateFontSize("choicefieldgroup", newConfig.fontSize);
        diagLog('Selected value:', newConfig.fontSize);

        $('#mw-btn-apply').prop('disabled', newConfig.fontSize == config.fontSize);

    });


    $('#mw-btn-apply').on('click', function () {

      setConfig(newConfig, function(result){
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          console.error(`Action failed with message ${result.error.message}`);
        } else {
          diagLog(`Settings saved with status: ${result.status}`);
        }
      });
      config.fontSize = newConfig.fontSize;
      updateFontSize("mw-prop-list", newConfig.fontSize);
      updateFontSize("mw-prop-list-advanced", newConfig.fontSize);
      closeSettings(NavType.FloatingDiv);
    });

    $('#mw-btn-cancel-settings').on('click', function () {
      closeSettings(NavType.FloatingDiv);
    });

    $('.ms-Dialog-buttonClose').on('click', function () {
      closeSettings(NavType.FloatingDiv);
    });

    $('#mw-btn-advanced-open').on('click', function () {
      openAdvanced();
    });
    $('#mw-btn-advanced-close').on('click', function () {
      closeAdvanced();
    });
    $('.mw-lbl-ver').text(ver);

  }

  //NavType: anopther page only
  //
  function updateFontSize_whenSettingsPage() {
    let fontSize = null;

    if (sessionStorage) {
      fontSize = sessionStorage.getItem("fontSize");
    }

    if (fontSize) {
      updateFontSize("mw-prop-list", fontSize);
      updateFontSize("mw-prop-list-advanced", fontSize);
    }
    else {
      const config = getConfig();

      // Check if add-in is configured.
      if (config && config.fontSize) {
        updateFontSize("mw-prop-list", config.fontSize);
        updateFontSize("mw-prop-list-advanced", config.fontSize);
      }
    }
  }

  //NavType: Office Api Dialog only
  //
  function receiveMessage(message) {
    if(message !== "close"){
      config = JSON.parse(message.message);
      setConfig(config, function(result) {        
        updateFontSize("mw-prop-list", config.fontSize);
        updateFontSize("mw-prop-list-advanced", config.fontSize);
      });
    }
    closeSettings(NavType.OfficeApiDialog);
  }

  function dialogClosed(message) {
    settingsDialog = null;
  }

  //NavType: All
  //  

  function isPersistenceSupported() {
    diagLog('isPersistenceSupported');
    return Office.context.mailbox.addHandlerAsync !== undefined;
  };  

  function displayMailboxItemData(item, internetHeaders) {
    diagLog('displayMailboxItemData');
    let replyTo = "";
    if(internetHeaders){
      var lines = internetHeaders.split(/\r?\n/);

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].toLowerCase();
        if (line.indexOf("reply-to:") === 0) {
          replyTo = parseReplyToHeader(lines[i].substring("reply-to:".length)); // preserve original casing and spacing

          break;
        }
      }
    }
    //if(!item){
      item = Office.context.mailbox.item;
    //}

    let insertAt = $("#mw-prop-list");
    insertAt.empty();

    if(!item){
      if(replyTo){
        appendListItem(insertAt, "Reply To:", parseEmailAddressDetails(replyTo));
      }
    }        
    else{
      let emailAddress = item.from && item.from.emailAddress && item.from.emailAddress.toLowerCase();
      if(emailAddress){
        appendListItem(insertAt, "From:", parseEmailAddressDetails(item.from));

        if(item.sender && item.sender.emailAddress && item.sender.emailAddress.toLowerCase() != emailAddress){
          appendListItem(insertAt, "Sender:", parseEmailAddressDetails(item.sender));
        }

        if(replyTo && replyTo.emailAddress && replyTo.emailAddress.toLowerCase() != emailAddress){
          appendListItem(insertAt, "Reply To:", parseEmailAddressDetails(replyTo));
        }
      }
      else{
        emailAddress = item.sender && item.sender.emailAddress;

        if(emailAddress){
          appendListItem(insertAt, "Sender:", parseEmailAddressDetails(item.sender));

          if(replyTo && replyTo.emailAddress && replyTo.emailAddress.toLowerCase() != emailAddress){
            appendListItem(insertAt, "Reply To:", parseEmailAddressDetails(replyTo));
          }
        }
        else{
          if(replyTo){
            appendListItem(insertAt, "Reply To:", parseEmailAddressDetails(replyTo));
          }
          else{
            //Show nothing
          }
        }
      }

      //appendListItem(insertAt, "To:", parseEmailAddressDetails(item.to));
      //appendListItem(insertAt, "Cc:", parseEmailAddressDetails(item.cc));
      //appendListItem(insertAt, "Bcc:", parseEmailAddressDetails(item.bcc));

      //body
      //const options = { asyncContext: itemParsingState };
      if(item.body && item.body.getAsync !== undefined){
        item.body.getAsync(Office.CoercionType.Html, (bodyResult) => {
          //if(bodyResult.asyncContext.isBodyParsed)
          if(window.isBodyParsed)
            return;

          if (bodyResult.status === Office.AsyncResultStatus.Failed) {
            appendListItem(insertAt, "URLs:", [`Failed to get body: ${bodyResult.error.message}`]);
            //console.log(`Failed to get body: ${bodyResult.error.message}`);
            return;
          }

          var urls = getUrlsFromHtml(bodyResult.value);
          if(!urls || 0 == urls.length){
            urls.push('No Links in this message');
          }
          appendListItem(insertAt, "URLs in body:", urls);

          //bodyResult.asyncContext.isBodyParsed = !0;
          window.isBodyParsed = !0;

        });
      }      

      //attachments

      if(item.getAttachmentsAsync !== undefined){
        const options = { asyncContext: { currentItem: item } };

        item.getAttachmentsAsync(options, (result) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
              appendListItem(insertAt, "URLs in attachments:", [`Failed to get attachments: ${result.error.message}`]);
              console.log(`Failed to get body: ${result.error.message}`);
              return;
          }

          if (result.value.length <= 0) {
              appendListItem(insertAt, "URLs in attachments:", ["No attachments"]);
              console.log("No attachments");
              return;
          }

          const currentItem = result.asyncContext.currentItem;
          for (let i = 0; i < result.value.length; i++) {
              currentItem.getAttachmentContentAsync(result.value[i].id, (asyncResult) => {
                  if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                      appendListItem(insertAt, `Attachment: ${result.value[i].id}`,[`Failed to get content: ${asyncResult.error.message}`]);
                      console.log(asyncResult.error.message);
                      return;
                  }

                  appendListItem(insertAt, `Attachment: ${result.value[i].id}`, getUrlsFromText(asyncResult.value.content));
                  console.log(asyncResult.value.content);
              });
          }

        });
      }

    }

  }

  function parseReplyToHeader(replyToHeader){
    var replyTo = null;
    if(!replyToHeader)
      return replyTo;

    replyToHeader = replyToHeader.trim();

    var match = replyToHeader.match(/<([^<>]+)>$/);

    replyTo = {};
    if (match) {      
      replyTo.emailAddress = match[1];
      var lx = replyToHeader.lastIndexOf('<');
      if(lx != -1){
        replyTo.displayName = replyToHeader.substring(0, lx).trim();
      }
      else
      {
        replyTo.displayName = '';
      }
    } else {
      replyTo.emailAddress = replyToHeader;
      replyTo.displayName = '';
    }

    return replyTo;
  }

  function getUrlsFromText(text){
    const urls = text.match(/\bhttps?:\/\/[^\s]+/gi);

    return urls;
  }

  function getUrlsFromHtml(htmlText){
    const urls = [];

    const $html = $('<div>').html(htmlText); // Convert string to jQuery DOM

    const selectors = [
        ['a', 'href', 'Link URL'],
        ['area', 'href', 'Image map URL'],
        ['link', 'href', 'Resource URL'],
        ['form', 'action', 'Form action URL'],
        ['script', 'src', 'Script URL'],
        ['img', 'src', 'Image URL'],
        ['iframe', 'src', 'Iframe URL'],
        ['video', 'src', 'Video URL'],
        ['audio', 'src', 'Audio URL'],
        ['source', 'src', 'Audio source URL'],
        ['embed', 'src', 'Embedded object URL'],
        ['object', 'data', 'Object data URL']
    ];

    selectors.forEach(([tag, attr, kind]) => {
        $html.find(tag).each(function () {
            let val = $(this).attr(attr);                        
            if (val) {
              let desc = '';              
              if('a' == tag){
                const txt = $(this).text().trim();                
                if(txt){
                  desc = `${kind}\n${txt}\n`;
                }
                else{
                  desc = kind + '\n';
                }
              }
              else{
                let alt = $(this).attr('alt');
                if(alt)
                  alt = alt.trim();
                if(alt){
                  desc = `${kind}\n${alt}\n`;
                }
                else{
                  desc = kind + '\n';
                }                
              }

              if(desc){
                val = desc + val;
              }

              urls.push(val);
            }
        });
    });

    return urls;
  }

  function parseEmailAddressDetails(prop) {
    const arr = [];

    if(prop){
      if(Array.isArray(prop)){
        $.each(prop, function (index, value) {
          if (value && value.emailAddress){
            //let text = value.emailAddress;
            let text = value.displayName;
            if(text)
                text += "\n";
            text += value.emailAddress;
            //text += "Type:" + getRecipientType(value.recipientType);

            arr.push(text);
          }
            
        });
      }
      else
      {
        if (prop && prop.emailAddress){
            //let text = prop.emailAddress;
            let text = prop.displayName;
            if(text)
                text += "\n";
            text += prop.emailAddress;
          //text += "Type:" + getRecipientType(prop.recipientType);

          arr.push(text);
        }
      }
    }      
    
    return arr;
  }

  function getRecipientType(recipientType){
    var label = "undefined";
    switch(recipientType){
      case Office.MailboxEnums.RecipientType.DistributionList:
        label = "Distribution List";
        break;
      case Office.MailboxEnums.RecipientType.ExternalUser:
          label = "External User";
          break;
      case Office.MailboxEnums.RecipientType.User:
          label = "Internal User";
          break;
      case Office.MailboxEnums.RecipientType.Other:
        label = "Other";
        break;        
    }
    return label;
  }

  function appendListItem(insertAt, propLabel, arrPropVal) {

    const $propLabel = $("<div>", { class: "mw-prop-label" })
      .text(propLabel);      

    insertAt.append($propLabel);

    if(!arrPropVal || arrPropVal.length === 0)
      arrPropVal = [""];
    
    $.each(arrPropVal, function(index, propVal) {

      const $propVal = $("<div>", { class: "mw-prop-val" })
      .append(
        $("<pre>").append(
          $("<code>").text(propVal)
        )
      );

      insertAt.append($propVal);
    });    
  }

 function askAgent(item) {
  diagLog('askAgent');

    item.body.getAsync(Office.CoercionType.Text, function (result) {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const emailText = result.value;

        $.ajax({
          url: 'https://api.openai.com/v1/chat/completions',
          type: 'POST',
          headers: {
            'Authorization': 'Bearer YOUR_OPENAI_API_KEY',
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            model: 'gpt-4',
            messages: [
              { role: 'system', content: 'You are an email security analyst.' },
              { role: 'user', content: `Check if this email is a scam:\n\n${emailText}` }
            ]
          }),
          success: function (response) {
            const verdict = response.choices[0].message.content;

            // Save to sessionStorage so dialog can access it
            sessionStorage.setItem('verdict', verdict);

            Office.context.ui.displayDialogAsync(
              window.location.origin + '/dialog.html',
              { height: 50, width: 50 },
              function (asyncResult) {
                if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {                  
                  console.error('Dialog failed to open:', asyncResult.error.message);
                  showErrorDialog(`Dialog failed to open: ${asyncResult.error.message}`);
                }
              }
            );
          },
          error: function (err) {
            console.error('Error with OpenAI API:', err);
            showErrorDialog(`Error with OpenAI API: ${err}`);
          }
        });
      } else {
        console.error('Failed to get email body:', result.error.message);
        showErrorDialog(`Failed to get email body: ${result.error.message}`);
      }
    });

  } 

  function checkFabricUIRadioButton(fontSize) {
    if(!fontSize){
      fontSize = "s";
    }

    const selector = `input[name="mw-in-fs"][value="${fontSize}"]`;
    const $selected = $(selector);

    // Set selected radio
    $selected.prop('checked', true);
    $selected.closest('.ms-RadioButton')
      .find('.ms-RadioButton-field')
      .attr('aria-checked', 'true').addClass('is-checked');;

    // Uncheck others
    $('input[name="mw-in-fs"]').not($selected).each(function() {
      $(this).prop('checked', false);
      $(this).closest('.ms-RadioButton')
        .find('.ms-RadioButton-field')
        .attr('aria-checked', 'false').removeClass('is-checked');
    });
  }

  function openSettings(navType){
    if(navType == NavType.Page){
      //let url = new URI('dialog.html').absoluteTo(window.location).toString();

      window.location.href = "settings.html?v=" + ver; 
      return;
    }
    else if(navType == NavType.OfficeApiDialog){
      let url = getAbsoluteUrl('settings.html?v=' + ver);
      if (config) {
        // If the add-in has already been configured, pass the existing values
        // to the dialog.
        url = url + '?fs=' + config.fontSize;
      }

      const dialogOptions = { width: 20, height: 40, displayInIframe: true };

      Office.context.ui.displayDialogAsync(url, dialogOptions, function(result) {
        settingsDialog = result.value;
        settingsDialog.addEventHandler(Office.EventType.DialogMessageReceived, receiveMessage);
        settingsDialog.addEventHandler(Office.EventType.DialogEventReceived, dialogClosed);
      });

    }
    else{
      $('#mw-dlg-settings').show();
      $('.ms-Dialog-overlay').show();

      checkFabricUIRadioButton(config.fontSize);
    }
    
  }

  function closeSettings(navType){
    if(navType == NavType.Page){
      //let url = new URI('dialog.html').absoluteTo(window.location).toString();

      window.location.href = "taskpane.html"; 
      return;
    }
    else if(navType == NavType.OfficeApiDialog){
      if(settingsDialog){
        settingsDialog.close();
        settingsDialog = null;
      }
    }
    else{
      $('#mw-dlg-settings').hide();
      $('.ms-Dialog-overlay').hide();
    }
  }

  function showAdvancedSection(){
    $('.ms-Accordion').show();
  }

  function closeAdvanced(){
    let $btnClose = $('#mw-btn-advanced-close');
    if(isHidden($btnClose)){
      return;
    }
    hide($btnClose);
    let $btnOpen = $('#mw-btn-advanced-open');
    show($btnOpen);    

    const $accordionBody = $('#mw-acc-item-advanced .accordion-body');
    hide($accordionBody);
  }

  function openAdvanced(){
    let $btnOpen = $('#mw-btn-advanced-open');
    if(isHidden($btnOpen)){
      return;
    }
    hide($btnOpen);
    let $btnClose = $('#mw-btn-advanced-close');
    show($btnClose);  

    const $accordionBody = $('#mw-acc-item-advanced .accordion-body');
    show($accordionBody);

    if(!isInternetHeadersLoaded){
      //is opened
      let item = Office.context.mailbox.item;
      item.getAllInternetHeadersAsync(function (result) {
        isInternetHeadersLoaded = !0;

        hide($('#mw-spin-advanced'));

        let $insertAt = $('#mw-prop-list-advanced');
        $insertAt.empty();

        if (result.status === Office.AsyncResultStatus.Succeeded) {
            const headers = result.value;
            appendListItem($insertAt, "Internet Headers:", [headers]);
        } else {
          const err = result.error;
          appendListItem($insertAt, "Internet Headers:", [`Failed to get Internet Headers: ${err}`]);
          console.error(`Failed to get Internet Headers: ${err}`);
        }
      });
    }
  }

  function resetAdvanced(){    
    show($('#mw-spin-advanced'));
    isInternetHeadersLoaded = !1;
    $('#mw-prop-list-advanced').empty();
    closeAdvanced();
  }

  function showError(error) {
    $('#not-configured').hide();
    $('#error-display').text(error);
    $('#error-display').show();
  }

  function showErrorDialog(message) {
    $('.ms-Dialog-overlay').show();
    $('#mw-dlg-error p').text(message);
    $('#mw-dlg-error').show();
  }

  function hideErrorDialog() {
    $('#mw-dlg-error').hide();
    $('.ms-Dialog-overlay').hide();
  }

  function isHidden($node){
    //return $node.is(":hidden");
    return $node.hasClass("hidden");
  }

  function hide($node){
    //$node.hide();
    $node.addClass("hidden");
  }

  function show($node){
    //$node.show();
    $node.removeClass("hidden");
  }
  
  initOfficeOnReady();

  diagLog('script ends');
})();



  
